import React from "react";

// All your SVG icons defined inline - no network requests needed
export const SVG_DATA = {
    sealyLogo: (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 161.8 124"
        >
            <g>
                <path
                    style={{ fill: "#004e9a" }}
                    d="M147.5,9.4c-1.7-5.9-5.7-7.9-11.7-7.9c-16.6,0-49.8,13.1-54.9,15c-5-1.9-38.3-15-54.9-15c-6.1,0-10,2-11.7,7.9
        C11.6,18.7,9.5,38.4,9.5,62s2.1,43.3,4.8,52.7c1.7,5.9,5.7,7.9,11.7,7.9c16.6,0,49.8-13.1,54.9-15c5,1.9,38.3,15,54.9,15
        c6.1,0,10-2,11.7-7.9c2.7-9.3,4.8-29.1,4.8-52.7S150.1,18.7,147.5,9.4z"
                />
                <path
                    style={{ fill: "#fff" }}
                    d="M127.7,36.8C110.6,28,89.1,19.6,80.9,16.4C72.7,19.6,51.2,28,34.1,36.8C24.2,41.9,18.2,51.1,18.2,62v0
        c0,10.9,6,20.1,15.8,25.2c17.1,8.8,38.6,17.2,46.8,20.4c8.2-3.2,29.7-11.5,46.8-20.4c9.9-5.1,15.8-14.3,15.8-25.2v0
        C143.6,51.1,137.6,41.9,127.7,36.8"
                />
                <g>
                    <path
                        d="M123.3,74.7c-0.9,0-1.5-0.7-1.5-1.5c0-0.9,0.7-1.5,1.5-1.5c0.9,0,1.5,0.7,1.5,1.5C124.8,74,124.1,74.7,123.3,74.7
             M123.3,71.4c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C125.1,72.2,124.3,71.4,123.3,71.4"
                    />
                    <path
                        d="M122.9,72.5h0.5c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2-0.1,0.2
            c-0.1,0-0.1,0.1-0.2,0.1h-0.5V72.5z M124.1,73.9c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1
            c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.2-0.4
            c-0.1-0.1-0.3-0.1-0.5-0.1h-0.9v2h0.4v-0.8h0.5c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0.1,0,0.1,0,0.2
            c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1l0,0h0.4l0,0C124.1,74.1,124.1,74,124.1,73.9"
                    />
                    <path
                        d="M54.3,39.2c4.4,0,3,6.4,7.6,6.4c1.5,0,3-1.3,3-3.1c0-3.6-4.3-6.2-8.6-6.2c-6.4,0-12,5-12,14.4c0,5.4,1.6,12.6,1.6,18.1
            c0,3.2-1.3,5.5-3.8,5.5c-4.6,0-4.9-6.3-9-6.3c-1.7,0-3,1.3-3,3.2c0,3.7,4.5,6.5,9.2,6.5c8.4,0,12.1-6.1,12.1-11.5
            c0-9-1.4-12.6-1.4-20.7C50.1,41.7,51.9,39.2,54.3,39.2"
                    />
                    <path
                        d="M84.4,64c-2.5,4.8-5.4,9-7,9c-0.6,0-0.9-0.5-0.9-1.4c0-6.7,8.4-21,11.4-21c0.7,0,0.9,0.7,0.9,1.4c0,1.3-0.6,3.5-1.6,6
            L84.4,64z M60.6,64.2c1.4-5.1,7.3-14.2,9.9-14.2c0.4,0,0.7,0.2,0.7,0.8c0,3.7-6.1,12.8-10.2,13.8C60.8,64.7,60.5,64.6,60.6,64.2
             M130.3,47.9c-0.1,0-1.1-0.1-2.8-0.1c-1.7,0-2.5,0.1-2.7,0.1c-0.2,0-0.3,0.1-0.3,0.2c-0.6,1.3-3.7,8.5-6.9,15.7l0,0
            c-2.2,5.1-5.8,9.4-7.3,9.4c-1.4,0-0.6-2.4,0.7-5.4l8.8-19.6c0-0.1,0-0.2-0.1-0.2c-0.1,0-1.2-0.1-2.9-0.1c-1.7,0-2.5,0.1-2.8,0.1
            c-0.2,0-0.3,0.1-0.3,0.2c-0.6,1.4-4.3,9.7-7.1,16.3c-2.8,5.2-6.5,8.7-8,8.7c-1.2,0-0.5-1.9,0.3-3.8l14.6-33.3
            c0.1-0.1,0-0.3-0.2-0.3c-0.2,0-1.1-0.1-2.8-0.1s-2.5,0.1-2.7,0.1c-0.2,0-0.3,0.1-0.3,0.2L94.1,66.7c-2.5,4.2-5.1,6.5-6.5,6.5
            c-1.2,0-0.5-1.9,0.3-3.8l9.6-21.1c0.1-0.1,0-0.3-0.2-0.3c-0.2,0-1.1-0.1-2.7-0.1c-1.7,0-2.5,0.1-2.7,0.1c-0.2,0-0.3,0.1-0.3,0.2
            l-1.1,2.5c-0.1-1.5-0.7-3-2.8-3c-5.3,0-11.5,7.5-14.7,15.4v0c-3.2,5.3-9.7,10.8-12.4,10.8c-1.2,0-2-0.5-2-2.4
            c0-1.5,0.5-3.1,0.8-3.9c0.2-0.4,0.4-0.5,0.7-0.5c7.9-1.3,14.3-9.2,14.3-15c0-3.1-2.2-4.4-4.4-4.4c-6.7,0-16.9,14-16.9,23.9
            c0,3.7,1.5,6.1,5,6.1c4,0,9.7-4.6,13.2-9.9c-0.4,1.6-0.6,3.2-0.6,4.7c0,3.2,1.2,5.1,3.4,5.1c2.8,0,5.3-2.9,7.3-6
            c-0.7,3.4,0.1,6,2.9,6c2.6,0,6-3.1,8.1-6.2c-0.8,3.5,0,6.2,2.9,6.2c2.7,0,6.5-3.6,8.7-6.9c-1,4.2,0,6.9,2.4,6.9
            c2.3,0,4.8-2.1,7.1-5.1c-1.6,3.7-2.9,6.6-3.2,7.4c-1.1,2.8-2.1,5.1-4.7,5.1c-3.7,0-4.6-4.6-7.9-4.6c-1.6,0-2.4,1.2-2.4,2.4
            c0,2.6,4,4.6,7.7,4.6c7.2,0,11.8-5.8,14.5-12l12.7-27.1C130.6,48.1,130.5,48,130.3,47.9"
                    />
                </g>
            </g>
        </svg>
    ),
    tempurpedicLogo: (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0.6 54.5 148.9 41.2"
            enableBackground="new 0.6 54.5 148.9 41.2"
        >
            <g>
                <g>
                    <polygon
                        fill="#1F356E"
                        points="4.6,82.9 0.9,82.9 0.9,79.9 12.3,79.9 12.3,82.9 8.6,82.9 8.6,95.1 4.6,95.1 		"
                    />
                    <polygon
                        fill="#1F356E"
                        points="13.5,79.9 24.2,79.9 24.2,82.8 17.5,82.8 17.5,86 23.8,86 23.8,88.8 17.5,88.8 17.5,92.2
			24.4,92.2 24.4,95.1 13.5,95.1 		"
                    />
                    <polygon
                        fill="#1F356E"
                        points="25.9,79.9 32.3,79.9 35.5,90 35.5,90 38.9,79.9 45,79.9 45,95.1 41.1,95.1 41.1,83.5 41.1,83.5
			37.2,95.1 33.5,95.1 29.8,83.5 29.7,83.5 29.8,95.1 25.9,95.1 		"
                    />
                    <path
                        fill="#1F356E"
                        d="M47.2,79.9H52c4.6,0,6.8,1.6,6.8,5c0,3-2.3,4.9-6,4.9h-1.6v5.3h-4.1V79.9z M51.2,86.9h1.1
			c1.4,0,2.5-0.5,2.5-2.1c0-1.5-1.1-2-2.5-2h-1.1V86.9z"
                    />
                    <path
                        fill="#1F356E"
                        d="M73.3,89.3c0,4.1-2.7,6-6.6,6c-4,0-6.6-1.8-6.6-6v-9.4h4.1v8.7c0,2,0.6,3.7,2.6,3.7s2.6-1.7,2.6-3.7v-8.7
			h4.1L73.3,89.3L73.3,89.3z"
                    />
                    <path
                        fill="#1F356E"
                        d="M75,79.9h7.2c2.7,0,4.9,1.2,4.9,3.8c0,2-1,3.4-2.9,3.8v0c1.3,0.4,1.4,1.5,2.2,3.4l1.5,4.1h-4.2l-0.9-2.7
			c-0.8-2.6-1.3-3.3-2.9-3.3h-0.8v6H75L75,79.9L75,79.9z M79,86.2H80c1.3,0,2.9,0,2.9-1.7c0-1.4-1.4-1.7-2.9-1.7H79V86.2z"
                    />
                    <path
                        fill="#65BC47"
                        d="M95.3,79.9h4c3.1,0,5.7,1.1,5.7,4.6c0,3.4-2.6,4.6-5.3,4.6h-2.1v6.1h-2.2L95.3,79.9L95.3,79.9z M97.4,87.1
			h2.2c1.3,0,3-0.7,3-2.7c0-1.9-2-2.6-3.4-2.6h-1.8V87.1z"
                    />
                    <path
                        fill="#65BC47"
                        d="M116.3,79.9h4.5c4.5,0,8.1,2.8,8.1,7.5c0,5.1-3.1,7.7-8.1,7.7h-4.5V79.9z M118.5,93.2h2.3
			c3.7,0,5.8-1.8,5.8-5.7c0-3.5-2.4-5.6-5.5-5.6h-2.5L118.5,93.2L118.5,93.2z"
                    />
                    <rect
                        x="130.4"
                        y="79.9"
                        fill="#65BC47"
                        width="2.2"
                        height="15.1"
                    />
                    <path
                        fill="#65BC47"
                        d="M145.3,82.5c-1-0.6-2-0.8-3.1-0.8c-3.5,0-5.8,2.5-5.8,5.9c0,3.5,2.6,5.9,5.7,5.9c1.1,0,2.5-0.3,3.3-0.7
			l0.1,2.1c-1.2,0.5-2.6,0.6-3.5,0.6c-4.8,0-8-3.1-8-7.9c0-4.7,3.4-7.8,8-7.8c1.2,0,2.3,0.2,3.4,0.6L145.3,82.5z"
                    />
                    <path
                        fill="#65BC47"
                        d="M146.9,81c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2S146.9,81.7,146.9,81 M149,81
			c0-0.6-0.4-1-0.9-1s-0.9,0.4-0.9,1s0.4,1,0.9,1C148.6,82,149,81.6,149,81 M147.7,80.3h0.5c0.3,0,0.5,0.1,0.5,0.4
			c0,0.2-0.1,0.4-0.4,0.4l0.4,0.6h-0.3l-0.4-0.6h-0.1v0.6h-0.3L147.7,80.3L147.7,80.3z M147.9,80.9h0.2c0.1,0,0.3,0,0.3-0.2
			c0-0.2-0.1-0.2-0.3-0.2h-0.2V80.9z"
                    />
                    <rect
                        x="87.6"
                        y="87.1"
                        fill="#65BC47"
                        width="5.9"
                        height="2"
                    />
                    <polygon
                        fill="#65BC47"
                        points="106.3,79.9 114.8,79.9 114.8,81.9 108.4,81.9 108.4,86.3 114.2,86.3 114.2,88.2 108.4,88.2
			108.4,93.2 114.8,93.2 114.8,95.1 106.3,95.1 		"
                    />
                </g>
                <path
                    fill="#1F356E"
                    d="M44.6,67.9C44.6,67.9,44.6,68,44.6,67.9c0,0.1,0,0.1,0.1,0.1l0,0l0,0l0.2,0h0c4.6,1.2,10.6,0.9,12.3,0.7
		c2.6-0.2,5.7,0,7.3,0.2c0,0,0.1,0,0.1-0.1l0,0c0,0,0-0.1-0.1-0.1c-1.4-0.2-6.3-0.9-9-0.7c-2.5,0.2-5.9,0.1-10.7-0.2
		C44.8,67.9,44.8,67.9,44.6,67.9L44.6,67.9C44.7,67.8,44.6,67.9,44.6,67.9"
                />
                <path
                    fill="#1F356E"
                    d="M133,71.8c-0.4-0.4-1.1-0.3-1.6-0.3c-0.3,0-0.6,0.1-0.7,0c-1.7-1.4-2.5-0.9-3.6-0.2
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.6,0.3c-0.4,0.2-0.9,0.4-1.4,0.6c-0.7,0.2-1.6,0.2-2.7,0.1c-1.8-0.2-4.1-1.2-6.5-2.4
		c-3.5-1.7-7.5-3.5-11.3-3.3c-6.4,0.4-8.7-0.2-15.2-4c-8.4-4.7-13-6.3-19.8-3.4c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.7,0.3-1.1,0.4
		c-0.2,0.1-0.4,0.1-0.6,0.2c-4.9,1.7-7.4,0.6-12.5-1.7l-4-1.7c-8.5-3.6-11-2.2-13,1.9c-1.2,2.6-2.5,4.3-3.7,5.2
		c-0.6-1.6-2.3-2.8-3.6-3.1c-2.2-0.5-3.6-1.2-3.9-1.4c0,0-1.2-1.5-3.5-1.8c-2.5-0.4-4.3,0.3-5.6,1.3c-1.5,1.2-2.4,3.2-2.2,5.3
		c0.4,2.8,2,4.5,2,4.5c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.8-1-1.3-2-1.5-3.7c-0.1-1.7,0.3-3.6,1.7-4.9c1.7-1.5,3.8-1.7,5.6-1.3
		c2.2,0.6,3.3,2.8,4,4.7c0.7,2.1,1.5,4.3,5,4c2-0.1,3.7,0.8,4.5,2.5c0.8,1.7,0.2,3.7-1.5,5.3c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0
		l0.8-0.8c1.6-1.7,1.9-3.7,1.1-5.5c-0.7-1.6-2.4-2.5-4.4-2.4c-3.6,0.1-4.1-1.7-4.7-3.7c-0.3-0.9-0.6-1.7-1.2-2.5
		c0.7,0.5,1.6,0.8,3,1.1c1.2,0.3,2.7,1.3,3.4,2.7c-0.1,0-0.3,0.1-0.5,0.2c-0.9,0.2-1.8,0-2.8-0.7c-0.1,0-0.2-0.1-0.2-0.2l0,0
		c0,0-0.1,0-0.1,0v0c0,0,0,0,0,0.1l0,0l0.2,0.1c0,0,0,0,0.1,0c0.8,0.6,2,1.2,3.4,0.9c1.6-0.4,3.1-2.1,4.6-5.2
		c1.8-3.8,3.5-5.1,12.1-1.7c1.8,0.7,3.3,1.4,4.7,1.9c4.8,2.2,7,3,12.7,0.7c0.5-0.2,1.1-0.4,1.6-0.6c6.1-2.2,11.3-0.3,19.4,4.4
		c4.9,2.9,8,3,11.8,3.2c1.3,0.1,2.7,0.1,4.2,0.3c4.3,0.5,7.4,2,10.1,3.3l0,0c-7.3-2.5-10.5-1.8-13.5-1.2c-1.8,0.4-3.5,0.7-5.8,0.2
		c-10-2.3-13.8-1.7-16.1-1.2c0.6-0.7,0.8-1.7,0.7-2.8c-0.1-0.8-0.3-1.7-0.8-2.6c0,0,0,0-0.1,0h0c0,0,0,0,0,0.1c0,0,0,0,0,0
		c0.3,0.6,0.4,1.2,0.5,1.7c0.2,1.8-0.7,3.3-1.9,4.1c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0,0.1c0.4,0.1,0.8,0.6,1.1,1.2
		c0.2,0.4,0.3,0.9,0.4,1.5c0.1,0.9,0,1.9-0.4,2.9v0c0,0,0,0,0,0.1c0,0,0.1,0,0.1,0l0,0l0,0l0,0c0.7-1,1-2.6,0.9-3.9
		c0-0.2-0.1-0.5-0.1-0.7c-0.1-0.3-0.2-0.6-0.3-0.7l0,0l0.3,0c2.3-0.4,5.7-1.1,15.9,0.9c2.3,0.4,4,0.2,5.8,0
		c3.3-0.4,7.3-0.9,17.2,2.2l0,0c0.7,0.2,1.3,0.4,2,0.4c1.9,0.2,3.2-0.1,4.2-0.6c0.8-0.2,1.4-0.5,1.9-0.8c1.2-0.5,2.1-0.7,3.5,0.5
		c0.2,0.2,0.6,0.1,1,0c0.6-0.1,1.2-0.2,1.6,0.2c0.5,0.4,0.3,1.9,0.3,2.7c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1v0l0,0
		c0-0.3,0.2-1.7,0.2-1.9C133.4,72.6,133.2,72.1,133,71.8"
                />
                <path
                    fill="#1F356E"
                    d="M33.5,68.8c-2-1.3-4.7-0.3-7.2,0.9c-5.9,2.9-6.3,0-10.9,0c-2.4,0-2.7,2-2.7,2.7s0.2,2,0.6,2.9l0,0l0,0l0,0
		c0,0,0.1,0.1,0.1,0c0,0,0.1-0.1,0-0.1c-0.5-1.3-0.6-4.2,2-4.2c4.1,0,5.2,3,11.1-0.1c2.2-1.2,4.2-2,6-0.8c1.2,0.8,1.8,2.9,0.8,5.1
		c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0.1-0.1c0,0,0,0,0,0C35.3,72.3,35.7,70.3,33.5,68.8"
                />
            </g>
        </svg>
    ),
    sealyStearnsLogo: (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1043.1 407"
        >
            <g id="Group_9413" transform="translate(-449 -115.955)">
                <path
                    id="Path_69_00000140712969012720054700000010360307006521330109_"
                    style={{ fill: "#1d4f91" }}
                    d="M721.2,301.7c-3-10.6-10.1-14.2-21-14.2
		c-29.7,0-89.2,23.4-98.2,26.8c-9-3.4-68.6-26.8-98.2-26.8c-10.8,0-17.9,3.6-21,14.2c-4.8,16.7-8.6,52.1-8.6,94.3s3.8,77.6,8.6,94.3
		c3,10.6,10.1,14.2,21,14.2c29.7,0,89.2-23.4,98.2-26.8c9,3.4,68.6,26.8,98.2,26.8c10.8,0,17.9-3.6,21-14.2
		c4.8-16.7,8.6-52.1,8.6-94.3S726,318.4,721.2,301.7"
                />
                <path
                    id="Path_70_00000132779807635425475160000010958081029647280801_"
                    style={{ fill: "#fff" }}
                    d="M685.9,350.9
		C655.2,335,616.8,320,602,314.3c-14.7,5.6-53.2,20.7-83.9,36.5c-17.7,9.1-28.4,25.6-28.4,45.1l0,0c0,19.6,10.7,36,28.4,45.1
		c30.7,15.8,69.1,30.9,83.9,36.5c14.7-5.6,53.2-20.7,83.9-36.5c17.7-9.1,28.4-25.6,28.4-45.1l0,0C714.2,376.4,703.5,360,685.9,350.9
		"
                />
                <path
                    id="Path_71_00000046330757562645278320000011431299341280993168_"
                    d="M677.9,418.8c-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8
		s2.8,1.2,2.8,2.8c0,0,0,0,0,0C680.7,417.6,679.4,418.8,677.9,418.8 M677.9,412.8c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2
		c1.8,0,3.2-1.4,3.2-3.2C681.1,414.2,679.7,412.8,677.9,412.8"
                />
                <path
                    id="Path_72_00000106848543072688474260000003919115687837818270_"
                    d="M677.2,414.8h0.9c0.1,0,0.1,0,0.2,0
		c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.2,0,0.2c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0.1h-0.9L677.2,414.8z
		 M679.4,417.4c0-0.2,0-0.4,0-0.5c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1l-0.1,0l0,0
		c0.1,0,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.3-0.1-0.5-0.3-0.7c-0.3-0.2-0.6-0.3-0.9-0.3h-1.7v3.5
		h0.7v-1.4h0.8c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3
		c0,0.1,0,0.2,0.1,0.3l0,0h0.8l-0.1-0.1C679.4,417.6,679.4,417.5,679.4,417.4"
                />
                <path
                    id="Path_73_00000172428034382008165050000017373378924273228456_"
                    d="M554.4,355.2c7.9,0,5.4,11.4,13.6,11.4
		c3-0.1,5.4-2.5,5.4-5.5c0-6.5-7.7-11.1-15.4-11.1c-11.5,0-21.4,8.9-21.4,25.8c0,9.7,2.9,22.6,2.9,32.4c0,5.8-2.4,9.9-6.9,9.9
		c-8.2,0-8.8-11.4-16.1-11.4c-3.1,0-5.3,2.3-5.3,5.7c0,6.6,8,11.6,16.5,11.6c15,0,21.7-11,21.7-20.7c0-16.2-2.5-22.5-2.5-37.1
		C546.9,359.6,550,355.2,554.4,355.2"
                />
                <path
                    id="Path_74_00000081647764338468429020000001324734460155464584_"
                    d="M608.3,399.6c-4.4,8.5-9.7,16.1-12.6,16.1
		c-1.1,0-1.7-0.9-1.7-2.5c0-12.1,15-37.6,20.4-37.6c1.3,0,1.6,1.2,1.6,2.6c0,2.4-1.1,6.3-2.9,10.7L608.3,399.6z M565.7,400
		c2.5-9.1,13-25.4,17.7-25.4c0.7,0,1.2,0.5,1.3,1.1c0,0.1,0,0.2,0,0.2c0,6.5-10.8,22.9-18.2,24.8c-0.3,0.1-0.7-0.1-0.8-0.4
		C565.6,400.2,565.7,400.1,565.7,400 M690.6,370.8c-0.2,0-2-0.2-5-0.2c-3,0-4.5,0.2-4.8,0.2c-0.3,0-0.5,0.2-0.6,0.4
		c-1,2.4-6.7,15.2-12.4,28.1v0c-3.9,9.1-10.4,16.8-13,16.8c-2.5,0-1-4.3,1.2-9.7l15.8-35.2c0.1-0.1,0-0.3-0.2-0.4c0,0-0.1,0-0.1,0
		c-0.2,0-2.1-0.2-5.2-0.2c-3.1,0-4.5,0.1-4.9,0.2c-0.3,0-0.5,0.1-0.6,0.4c-1.1,2.6-7.8,17.4-12.6,29.2c-5.1,9.4-11.6,15.6-14.2,15.6
		c-2.1,0-1-3.3,0.6-6.9l26.1-59.6c0.1-0.2,0-0.4-0.2-0.5c-0.1,0-0.1,0-0.2,0c-0.3,0-2-0.2-4.9-0.2c-3,0-4.5,0.2-4.8,0.2
		c-0.3,0-0.5,0.2-0.6,0.4l-24.2,55c-4.5,7.5-9.2,11.7-11.6,11.7c-2.1,0-1-3.3,0.6-6.9l17.2-37.8c0.1-0.2,0-0.4-0.2-0.5
		c0,0-0.1,0-0.2,0c-0.3,0-2-0.2-4.9-0.2c-3,0-4.5,0.2-4.8,0.2c-0.3,0-0.5,0.2-0.6,0.4l-2,4.4c-0.1-2.7-1.3-5.4-5-5.4
		c-9.4,0-20.6,13.5-26.3,27.6l0,0c-5.7,9.5-17.4,19.4-22.1,19.4c-2.1,0-3.6-1-3.6-4.4c0.1-2.4,0.6-4.8,1.5-7
		c0.2-0.5,0.7-0.9,1.3-0.9c14.2-2.3,25.6-16.5,25.6-26.8c0-5.6-4-7.8-7.8-7.8c-12,0-30.3,25-30.3,42.8c0,6.6,2.7,11,9,11
		c7.2,0,17.4-8.3,23.7-17.8c-0.7,2.8-1.1,5.6-1.1,8.5c0,5.7,2.1,9.2,6.2,9.2c5,0,9.6-5.2,13.1-10.8c-1.2,6,0.3,10.8,5.2,10.8
		c4.7,0,10.7-5.6,14.6-11.2c-1.3,6.2,0.1,11.2,5.2,11.2c4.9,0,11.6-6.4,15.7-12.3c-1.9,7.5,0,12.3,4.3,12.3c4.1,0,8.7-3.8,12.7-9.2
		c-2.9,6.7-5.2,11.9-5.7,13.3c-2,5-3.8,9.1-8.4,9.1c-6.5,0-8.3-8.3-14.2-8.3c-2.3-0.1-4.2,1.7-4.3,4c0,0.1,0,0.2,0,0.3
		c0,4.6,7.1,8.2,13.7,8.2c12.9,0,21.1-10.5,26-21.5l22.7-48.5c0.1-0.2,0-0.3-0.2-0.4C690.7,370.8,690.6,370.8,690.6,370.8"
                />

                <rect
                    id="Rectangle_93_00000097473497012411816850000000212742622944756357_"
                    x="474.1"
                    y="287.5"
                    style={{ fill: "none" }}
                    width="255.7"
                    height="217"
                />
            </g>
            <g id="Group_9414" transform="translate(461.093 174.176)">
                <g>
                    <defs>
                        <rect
                            id="SVGID_1_"
                            x="25.1"
                            y="20.5"
                            width="529.7"
                            height="170.7"
                        />
                    </defs>
                    <clipPath id="SVGID_00000038393579421924433640000008049039394322864010_">
                        <use
                            xlinkHref="#SVGID_1_"
                            style={{ overflow: "visible" }}
                        />
                    </clipPath>

                    <g
                        id="Group_2454_00000129887514769252954320000009332256884913378992_"
                        transform="translate(0 0)"
                        style={{
                            clipPath:
                                "url(#SVGID_00000038393579421924433640000008049039394322864010_)",
                        }}
                    >
                        <path
                            id="Path_1262_00000160153038172543251770000004894931807212427705_"
                            style={{ fill: "#19274f" }}
                            d="M220.6,71.6c-0.6,2.7-1.5,5.3-2.8,7.7
				c-1.2,2.3-2.7,4.4-4.5,6.2c-1.8,1.8-3.9,3.2-6.2,4.1c-2.5,1-5.2,1.5-7.9,1.5h-15.4V57h6c1.9-0.1,3.7,0.3,5.4,1.1
				c1.4,0.7,2.7,1.8,3.7,3c1,1.3,1.8,2.9,2.4,4.5c0.6,1.8,1.1,3.6,1.6,5.4l0.1,0.4h2.2V40.2H203l-0.1,0.4c-0.4,2-1,4-1.7,5.9
				c-0.6,1.6-1.5,3.1-2.6,4.4c-1.1,1.2-2.4,2.2-3.9,2.8c-1.9,0.7-3.9,1-5.9,1h-4.9v-29h14.9c2.7-0.1,5.4,0.5,7.8,1.7
				c2,1,3.8,2.4,5.2,4.1c1.3,1.5,2.4,3.1,3.2,4.9c0.6,1.3,1.2,2.7,1.6,4.2l0.1,0.4h2.2V23.2h-59.1v2.4h8.9v65.4h-8.9v2.4h63.1V71.1
				h-2.2L220.6,71.6z"
                        />
                        <path
                            id="Path_1263_00000124876485290600749870000009247112656473163964_"
                            style={{ fill: "#19274f" }}
                            d="M272.5,63.7h-20.8L261.9,39L272.5,63.7
				z M270.2,20.8l-0.1-0.3h-3.3l-28.9,70.5h-8.3v2.4h19.4v-2.4h-8.4l10.3-25h22.6l10.8,25h-8.8v2.4h33.7v-2.4h-8.5L270.2,20.8z"
                        />
                        <path
                            id="Path_1264_00000107553573771087453390000014836307224732347522_"
                            style={{ fill: "#19274f" }}
                            d="M355.1,46.2c-0.2,1.5-0.7,3-1.5,4.3
				c-0.9,1.3-2.1,2.3-3.6,3c-2.1,0.8-4.4,1.2-6.7,1.1h-3.5v-29l1.7-0.1c0.7-0.1,1.4-0.1,2.1-0.1c2-0.1,4,0.3,5.9,0.9
				c1.4,0.6,2.6,1.5,3.5,2.8c0.9,1.5,1.6,3.1,1.9,4.9c0.4,2.4,0.6,4.8,0.6,7.2C355.4,42.9,355.3,44.6,355.1,46.2 M383.8,88.6
				c-0.6,0.6-1.4,1.3-2.2,2.1c-0.8,0.7-1.8,1-2.9,1c-0.8,0.1-1.7-0.1-2.4-0.6c-0.7-0.7-1.1-1.5-1.3-2.4c-0.4-1.9-0.7-3.7-0.8-5.6
				l-0.8-9.8c-0.1-3-0.8-5.9-2-8.6c-1-2.1-2.6-3.8-4.5-5.1c-2-1.3-4.3-2.2-6.6-2.7c-2-0.5-4.3-0.9-6.7-1.4c1.7-0.2,3.3-0.6,4.9-1
				c2.2-0.6,4.4-1.5,6.3-2.7c1.9-1.2,3.5-2.8,4.7-4.7c1.3-2.1,1.9-4.5,1.8-6.9c0.1-3-0.7-5.9-2.4-8.4c-1.6-2.2-3.6-4-6-5.3
				c-2.5-1.3-5.1-2.2-7.9-2.7c-2.7-0.5-5.4-0.8-8.1-0.8c-2.8,0-5.5,0.1-8.1,0.1c-2.7,0.1-5.4,0.1-8,0.1h-15.2v2.4h8.9v65.4h-8.9v2.4
				h33v-2.4h-8.9V57h5.9c2.4-0.1,4.7,0.4,6.8,1.7c1.6,1.1,2.8,2.6,3.6,4.4c0.9,2.1,1.4,4.3,1.6,6.5c0.2,2.5,0.4,5.1,0.5,7.7
				c0.1,1.7,0.2,3.6,0.4,5.6c0.2,2,0.9,3.9,1.9,5.7c1.1,1.9,2.7,3.4,4.7,4.4c2.7,1.3,5.6,1.9,8.6,1.8c1.5,0,3-0.1,4.5-0.4
				c1.1-0.2,2.1-0.5,3.1-1c0.8-0.4,1.6-0.9,2.3-1.5c0.6-0.6,1.3-1.2,1.9-1.8l0.4-0.4l-1.8-1.6L383.8,88.6z"
                        />
                        <path
                            id="Path_1265_00000013163823416528680040000009705251360508508845_"
                            style={{ fill: "#19274f" }}
                            d="M438.3,25.7h8.9v43l-31.7-45.4h-23.7
				v2.4h8.9v65.4h-8.9v2.4h20.5v-2.4h-8.9V32l43.1,61.4h3.4V25.7h8.9v-2.4h-20.5V25.7z"
                        />
                        <path
                            id="Path_1266_00000156557988563887927860000004861913506946425277_"
                            style={{ fill: "#19274f" }}
                            d="M510.1,56.6c-2.1-1.6-4.3-2.9-6.8-3.9
				c-2.5-1-5.1-1.9-7.7-2.8c-2.6-0.8-5.2-1.6-7.7-2.4c-2.3-0.7-4.5-1.6-6.6-2.7c-1.7-0.9-3.3-2.2-4.6-3.7c-1.2-1.5-1.8-3.4-1.7-5.3
				c0-1.4,0.4-2.9,1-4.1c0.7-1.4,1.7-2.7,3-3.7c1.4-1.2,3.1-2.1,4.8-2.7c2.1-0.7,4.4-1.1,6.7-1c2.6-0.1,5.2,0.5,7.6,1.6
				c1.9,1,3.6,2.4,5,4.2c1.4,1.8,2.5,3.8,3.3,5.9c0.9,2.2,1.7,4.4,2.5,6.7l0.1,0.4h2.2V23.2h-2.4l-0.1,0.3c-0.2,0.5-0.5,1-0.8,1.4
				c-0.1,0.1-0.4,0.3-1.4,0.3c-0.8,0-1.6-0.2-2.4-0.5c-0.9-0.4-2.1-0.8-3.3-1.2s-2.7-0.8-4.3-1.2c-1.9-0.4-3.8-0.6-5.8-0.6
				c-3.3,0-6.5,0.6-9.6,1.7c-2.8,1.1-5.3,2.6-7.6,4.6c-2.1,1.8-3.8,4-5,6.5c-1.2,2.4-1.8,5-1.8,7.7c-0.1,3.1,0.5,6.2,1.8,9
				c1.1,2.3,2.7,4.4,4.6,6c2,1.6,4.2,3,6.5,4c2.4,1,4.9,1.9,7.4,2.6l7.4,2.2c2.2,0.6,4.3,1.5,6.3,2.6c1.7,0.9,3.2,2.2,4.3,3.7
				c1.1,1.7,1.7,3.6,1.6,5.6c0,1.5-0.3,3-0.8,4.4c-0.5,1.7-1.4,3.3-2.6,4.7c-1.4,1.6-3.1,2.9-5,3.8c-2.6,1.1-5.4,1.7-8.2,1.6
				c-1,0-2,0-3.1,0c-1.2,0-2.3-0.2-3.5-0.6c-1.3-0.4-2.6-1-3.9-1.7c-1.5-0.9-3-2-4.2-3.3c-1.3-1.2-2.4-2.6-3.4-4.1
				c-0.9-1.4-1.6-2.9-2.3-4.4c-0.6-1.3-1-2.6-1.4-4c-0.3-1.2-0.5-2.2-0.7-3l-0.1-0.4h-2.4v22.6h2.4l0.1-0.3c0.1-0.6,0.5-1.1,0.9-1.6
				c0.5-0.3,1.1-0.4,1.6-0.3c1,0.1,1.9,0.3,2.8,0.6c1.3,0.4,2.9,0.8,4.6,1.2s3.6,0.8,5.6,1.2c2,0.4,4,0.6,6.1,0.6
				c3.8,0,7.6-0.6,11.1-1.9c3.2-1.2,6.1-3,8.6-5.2c2.4-2.1,4.3-4.7,5.6-7.7c1.3-2.9,2-6.1,2-9.3c0.1-2.9-0.5-5.8-1.9-8.4
				C513.7,60.2,512.1,58.2,510.1,56.6"
                        />
                        <path
                            id="Path_1267_00000033364173695957583410000006365005173415287225_"
                            style={{ fill: "#19274f" }}
                            d="M41.8,150c0.9-0.7,1.9-1.5,3-2.4
				c0.1,0.3,0.3,0.7,0.6,1.2c0.4,0.9,0.8,1.8,1.3,2.7l14.6,28.2c0.3,0.7,0.7,1.4,1,2c0.3,0.5,0.7,1.2,1.2,1.9c-1.3,1-2.6,2-4.1,2.8
				c-1.4,0.8-2.9,1.2-4.4,1.1c-1.6,0-3.1-0.6-4.3-1.6c-1.6-1.2-3-2.6-4.2-4.1c-1.4-1.8-2.6-3.7-3.6-5.7c-1.1-2.1-2.1-4.2-2.9-6.4
				c-0.8-2-1.4-4-1.9-6c-0.4-1.5-0.6-3-0.7-4.5c0-1.3,0.1-2.6,0.5-3.9c0.3-1.1,0.8-2.1,1.4-2.9C40.1,151.6,40.9,150.7,41.8,150
				 M51.4,126.8c-0.1-1.3,0.2-2.5,0.8-3.7c0.4-0.8,1.1-1.4,1.8-1.9c0.6-0.4,1.2-0.6,1.9-0.7c0.7-0.1,1.1-0.1,1.3-0.1
				c0.9,0,1.9,0.2,2.7,0.7c0.7,0.5,1.4,1.1,1.8,1.9c0.5,0.8,0.9,1.7,1.1,2.7c0.2,1,0.4,2,0.4,3c0,1.4-0.2,2.8-0.8,4.1
				c-0.5,1.1-1.2,2.2-2,3.1c-0.7,0.9-1.6,1.6-2.5,2.3c-0.7,0.5-1.3,0.9-1.9,1.3c-0.5-0.8-1-1.8-1.5-2.7c-0.6-1.1-1.1-2.3-1.6-3.6
				c-0.5-1.1-0.8-2.3-1.1-3.4C51.6,128.8,51.4,127.8,51.4,126.8 M88.3,176.5l-0.1-0.3h-2.5l0.3,0.7c0.1,0.2,0.2,0.5,0.2,0.7
				c0,0.3,0,0.5,0,0.8c0,0.5-0.1,1-0.1,1.5c-0.1,0.8-0.3,1.6-0.6,2.3c-0.3,0.8-0.8,1.5-1.3,2.1c-0.5,0.5-1.2,0.8-1.9,0.8
				c-0.9,0.1-1.7-0.3-2.3-0.9c-0.5-0.5-0.9-1.1-1.3-1.7l-4.3-7.6c0.9-1.5,1.7-3.2,2.3-4.9c0.6-1.9,1.1-3.8,1.5-5.7
				c0.4-1.9,0.6-3.8,0.8-5.6c0.2-1.8,0.3-3.4,0.3-4.6c0.1-2.1,0.3-4.3,0.6-6.4c0.2-1.2,0.6-2.3,1.3-3.3c0.5-0.7,1.3-1.2,2.1-1.5
				c1.2-0.3,2.4-0.6,3.6-0.8l0.4-0.1v-2.3H66.5v2.4H67c1.4,0,2.9,0.1,4.3,0.5c1.1,0.3,2.1,0.9,2.9,1.7c0.9,1,1.5,2.3,1.8,3.6
				c0.5,2.1,0.7,4.3,0.6,6.4c0.1,4.1-0.4,8.1-1.4,12.1c-0.6,2-1.3,4-2.3,5.8l-15.7-30.7c3.3-2.3,5.6-4.5,6.6-6.7
				c1-2,1.6-4.2,1.7-6.4c0-1.6-0.2-3.3-0.8-4.8c-0.4-1.2-1.2-2.3-2.1-3.3c-0.9-0.8-2-1.4-3.1-1.8c-3.1-0.9-6.4-0.7-9.2,0.8
				c-1.8,0.9-3.4,2.1-4.8,3.6c-1.4,1.5-2.5,3.2-3.3,5.1c-0.8,1.9-1.3,3.9-1.3,6c0,1.8,0.3,3.5,0.8,5.2c0.5,1.6,1.2,3.7,2.2,6.2
				c-1.9,1.2-4,2.6-6.1,4c-2.2,1.5-4.3,3.3-6.1,5.2c-1.9,1.9-3.4,4.1-4.7,6.5c-1.3,2.6-1.9,5.4-1.9,8.3c0.1,2.1,0.4,4.2,0.9,6.2
				c0.7,2.6,1.9,5,3.6,7.1c2,2.5,4.5,4.5,7.3,5.9c3.1,1.6,7.2,2.4,12.2,2.4c1.9,0,3.7-0.1,5.5-0.5c1.4-0.3,2.9-0.7,4.2-1.3
				c1.2-0.5,2.3-1.1,3.3-1.9c0.8-0.6,1.6-1.2,2.5-1.9c1.1,1.4,2.4,2.7,3.9,3.7c2.1,1.3,4.5,1.9,6.9,1.8c2.6,0.1,5.3-0.5,7.5-1.9
				c1.6-1.1,3-2.5,3.9-4.2c0.8-1.4,1.3-2.9,1.5-4.4c0.2-1.8,0.2-2.3,0.2-2.4c0-0.4,0-0.7-0.1-1C88.5,177,88.4,176.7,88.3,176.5"
                        />
                        <path
                            id="Path_1268_00000181785095365443842540000001430609821655299512_"
                            style={{ fill: "#19274f" }}
                            d="M120.8,122h8.9v65.4h-8.9v2.4h33.1
				v-2.4h-9v-32.8h6c1.9-0.1,3.7,0.3,5.4,1.1c1.4,0.7,2.7,1.8,3.7,3c1,1.4,1.8,2.9,2.4,4.5c0.6,1.8,1.1,3.6,1.6,5.4l0.1,0.4h2.2
				v-31.3H164l-0.1,0.4c-0.4,2-1,4-1.7,5.9c-0.6,1.6-1.5,3.1-2.6,4.4c-1.1,1.2-2.4,2.2-3.9,2.8c-1.9,0.7-3.9,1-5.9,1h-4.9V122H159
				c2.2,0,4.5,0.3,6.6,1c1.8,0.7,3.4,1.7,4.8,3c1.4,1.4,2.7,2.9,3.6,4.7c1.1,2,2.1,4.1,2.9,6.2l0.1,0.3h2.1v-17.7h-58.4V122z"
                        />
                        <path
                            id="Path_1269_00000059992348813124927280000013298310115216802994_"
                            style={{ fill: "#19274f" }}
                            d="M240.6,154.1c0,5-0.2,9.7-0.5,14
				c-0.2,3.8-1.1,7.5-2.5,11c-1.2,2.9-3.3,5.4-5.9,7.2c-2.6,1.7-6.3,2.6-11,2.6c-3.1,0.1-6.2-0.4-9.2-1.5c-2.6-1-4.7-2.9-6.2-5.3
				c-1.8-3.2-3.1-6.7-3.6-10.4c-0.9-5.5-1.2-11.1-1.2-16.7c0-4.7,0.2-9.4,0.7-14c0.3-3.8,1.3-7.4,2.8-10.9c1.3-2.9,3.4-5.3,6-7
				c2.6-1.7,6.2-2.5,10.6-2.5c4.7,0,8.5,0.9,11.1,2.7c2.7,1.8,4.7,4.3,6,7.3c1.4,3.4,2.2,7,2.4,10.7
				C240.4,145.2,240.6,149.6,240.6,154.1 M245.9,127.9c-3.4-3.1-7.5-5.6-11.8-7.3c-8.5-3.4-17.9-3.4-26.4,0.1
				c-9,3.6-16.4,10.4-20.6,19.1c-4.4,9.3-4.5,20.1-0.3,29.5c4,8.7,11.1,15.5,19.9,19.2c4.4,1.9,9.2,2.8,14,2.8c4.8,0,9.6-1,14-2.9
				c8.8-3.8,15.9-10.8,19.8-19.6c2-4.4,3-9.2,3-14.1c0.1-5.3-1-10.5-3.2-15.2C252.2,135.1,249.4,131.2,245.9,127.9"
                        />
                        <path
                            id="Path_1270_00000123432073655300130070000008360303494185306777_"
                            style={{ fill: "#19274f" }}
                            d="M311.6,153c-2.1-1.6-4.3-2.9-6.8-3.9
				c-2.5-1-5.1-1.9-7.7-2.8c-2.6-0.8-5.2-1.6-7.7-2.4c-2.3-0.7-4.5-1.6-6.6-2.7c-1.7-0.9-3.3-2.2-4.6-3.7c-1.2-1.5-1.8-3.4-1.7-5.3
				c0-1.4,0.4-2.9,1-4.1c0.7-1.4,1.7-2.7,3-3.7c1.4-1.2,3.1-2.1,4.8-2.7c2.1-0.7,4.4-1.1,6.7-1c2.6-0.1,5.2,0.5,7.6,1.6
				c1.9,1,3.6,2.4,5,4.2c1.4,1.8,2.5,3.8,3.3,5.8c0.9,2.2,1.7,4.4,2.5,6.7l0.1,0.4h2.2v-19.5h-2.4l-0.1,0.3c-0.2,0.5-0.5,1-0.8,1.4
				c-0.1,0.1-0.4,0.3-1.4,0.3c-0.8,0-1.6-0.2-2.4-0.5c-0.9-0.4-2-0.8-3.3-1.2s-2.7-0.8-4.3-1.2c-1.9-0.4-3.8-0.6-5.8-0.6
				c-3.3,0-6.5,0.6-9.6,1.7c-2.8,1.1-5.3,2.6-7.6,4.6c-2.1,1.8-3.8,4-5,6.5c-1.2,2.4-1.8,5-1.8,7.7c-0.1,3.1,0.5,6.2,1.8,9
				c1.1,2.3,2.7,4.4,4.6,6c2,1.6,4.2,3,6.5,4c2.4,1,4.9,1.9,7.4,2.6l7.4,2.2c2.2,0.6,4.3,1.5,6.3,2.6c1.7,0.9,3.2,2.2,4.3,3.7
				c1.1,1.7,1.7,3.6,1.6,5.6c0,1.5-0.3,3-0.8,4.4c-0.5,1.7-1.4,3.3-2.6,4.7c-1.4,1.6-3.1,2.9-5,3.8c-2.6,1.1-5.4,1.7-8.2,1.6
				c-1,0-2,0-3.1,0c-1.2,0-2.3-0.2-3.5-0.6c-1.3-0.4-2.6-1-3.9-1.7c-1.5-0.9-3-2-4.2-3.3c-1.3-1.2-2.4-2.6-3.4-4.1
				c-0.9-1.4-1.6-2.9-2.3-4.4c-0.6-1.3-1-2.6-1.4-4c-0.3-1.2-0.5-2.3-0.7-3l-0.1-0.4h-2.4v22.6h2.4l0.1-0.3c0.1-0.6,0.5-1.1,0.9-1.6
				c0.5-0.3,1.1-0.4,1.6-0.3c1,0.1,1.9,0.3,2.8,0.6c1.3,0.4,2.9,0.8,4.6,1.2c1.7,0.4,3.6,0.8,5.6,1.2c2,0.4,4,0.6,6.1,0.6
				c3.8,0,7.6-0.6,11.1-1.9c3.2-1.2,6.1-3,8.6-5.2c2.4-2.1,4.3-4.7,5.6-7.7c1.3-2.9,2-6.1,2-9.3c0.1-2.9-0.5-5.8-1.9-8.4
				C315.3,156.5,313.6,154.6,311.6,153"
                        />
                        <path
                            id="Path_1271_00000183243972955593843320000016004292257481481355_"
                            style={{ fill: "#19274f" }}
                            d="M326.5,138.5h2.2l0.1-0.4
				c0.8-2.8,1.8-5.5,3.2-8.1c1-1.9,2.3-3.5,3.8-4.8c1.4-1.1,3.1-2,4.9-2.4c2.1-0.5,4.2-0.7,6.3-0.7h3v65.4h-8.9v2.4h33v-2.4H365V122
				h3c2.1,0,4.2,0.2,6.3,0.7c1.8,0.5,3.4,1.3,4.8,2.4c1.6,1.3,2.9,3,3.9,4.8c1.3,2.6,2.4,5.3,3.2,8.1l0.1,0.4h2.2v-18.8h-61.9V138.5
				z"
                        />
                        <path
                            id="Path_1272_00000127741012635029995480000005448673426342672567_"
                            style={{ fill: "#19274f" }}
                            d="M73.7,56.6c-2.1-1.6-4.3-2.9-6.8-3.9
				c-2.5-1-5.1-1.9-7.7-2.8c-2.6-0.8-5.2-1.6-7.7-2.4c-2.3-0.7-4.5-1.6-6.6-2.7c-1.7-0.9-3.3-2.2-4.6-3.7c-1.2-1.5-1.8-3.4-1.7-5.3
				c0-1.4,0.4-2.9,1-4.1c0.7-1.4,1.7-2.7,3-3.7c1.4-1.2,3.1-2.1,4.8-2.7c2.1-0.7,4.4-1.1,6.7-1c2.6-0.1,5.2,0.5,7.6,1.6
				c1.9,1,3.6,2.4,5,4.2c1.4,1.8,2.5,3.8,3.3,5.9c0.9,2.2,1.7,4.4,2.5,6.7l0.1,0.4h2.2V23.2h-2.4l-0.1,0.3c-0.2,0.5-0.5,1-0.8,1.4
				c-0.1,0.1-0.4,0.3-1.4,0.3c-0.8,0-1.6-0.2-2.4-0.5c-0.9-0.4-2-0.8-3.3-1.2c-1.2-0.4-2.7-0.8-4.3-1.2c-1.9-0.4-3.8-0.6-5.8-0.6
				c-3.3,0-6.5,0.6-9.6,1.7C42,24.5,39.5,26,37.2,28c-2.1,1.8-3.8,4-5,6.5c-1.2,2.4-1.8,5-1.8,7.7c-0.1,3.1,0.5,6.2,1.8,9
				c1.1,2.3,2.7,4.4,4.6,6c2,1.6,4.2,3,6.5,4c2.4,1,4.9,1.9,7.4,2.6l7.4,2.2c2.2,0.6,4.3,1.5,6.3,2.6c1.7,0.9,3.2,2.2,4.3,3.7
				C70,74,70.5,76,70.4,78c0,1.5-0.3,3-0.8,4.4c-0.5,1.7-1.4,3.3-2.6,4.7c-1.4,1.6-3.1,2.9-5,3.8c-2.6,1.1-5.4,1.7-8.2,1.6
				c-1,0-2,0-3.1,0c-1.2,0-2.3-0.2-3.5-0.6c-1.3-0.4-2.6-1-3.9-1.7c-1.5-0.9-3-2-4.2-3.3c-1.3-1.2-2.4-2.6-3.4-4.1
				c-0.9-1.4-1.6-2.9-2.3-4.4c-0.6-1.3-1-2.6-1.4-4c-0.3-1.2-0.5-2.3-0.7-3l-0.1-0.4H29v22.6h2.4l0.1-0.3c0.1-0.6,0.5-1.1,0.9-1.6
				c0.5-0.3,1.1-0.4,1.6-0.3c1,0.1,1.9,0.3,2.8,0.6c1.3,0.4,2.9,0.8,4.6,1.2c1.7,0.4,3.6,0.8,5.6,1.2c2,0.4,4,0.6,6.1,0.6
				c3.8,0,7.6-0.6,11.1-1.9c3.2-1.2,6.1-3,8.6-5.2c2.4-2.1,4.3-4.7,5.6-7.7c1.3-2.9,2-6.1,2-9.3c0.1-2.9-0.5-5.8-1.9-8.4
				C77.4,60.1,75.7,58.2,73.7,56.6"
                        />
                        <path
                            id="Path_1273_00000127009602304565361430000013010782316147283360_"
                            style={{ fill: "#19274f" }}
                            d="M88.6,42.1h2.2l0.1-0.4
				c0.8-2.8,1.8-5.5,3.2-8.1c1-1.9,2.3-3.5,3.8-4.8c1.4-1.1,3.1-2,4.9-2.4c2.1-0.5,4.2-0.7,6.3-0.7h3v65.4H103v2.4h33v-2.4h-8.9
				V25.7h3c2.1,0,4.2,0.2,6.3,0.7c1.8,0.5,3.4,1.3,4.8,2.4c1.6,1.3,2.9,3,3.8,4.8c1.3,2.6,2.4,5.3,3.2,8.1l0.1,0.4h2.2V23.2H88.6
				V42.1z"
                        />
                        <path
                            id="Path_1274_00000177447726841152041230000001498576859777825958_"
                            style={{ fill: "#19274f" }}
                            d="M458.4,167.9c-0.6,2.7-1.5,5.3-2.8,7.7
				c-1.2,2.3-2.7,4.4-4.5,6.2c-1.8,1.8-3.9,3.2-6.2,4.1c-2.5,1-5.2,1.5-7.9,1.5h-15.4v-34h6c1.9-0.1,3.7,0.3,5.4,1.1
				c1.4,0.7,2.7,1.8,3.7,3c1,1.4,1.8,2.9,2.4,4.5c0.6,1.8,1.1,3.6,1.6,5.4l0.1,0.4h2.2v-31.3h-2.2l-0.1,0.4c-0.4,2-1,4-1.7,5.9
				c-0.6,1.6-1.5,3.1-2.6,4.4c-1.1,1.2-2.4,2.2-3.9,2.8c-1.9,0.7-3.9,1-5.9,1h-4.9v-29h14.9c2.7-0.1,5.4,0.5,7.8,1.7
				c2,1,3.8,2.4,5.2,4.1c1.3,1.5,2.4,3.1,3.2,4.9c0.6,1.4,1.2,2.7,1.6,4.2l0.1,0.4h2.2v-17.7h-59.1v2.4h8.9v65.4h-8.9v2.4h63.1
				v-22.3h-2.2L458.4,167.9z"
                        />
                        <path
                            id="Path_1275_00000083079749752403642120000001052270564152736693_"
                            style={{ fill: "#19274f" }}
                            d="M509.9,142.6c-0.2,1.5-0.7,3-1.5,4.3
				c-0.9,1.3-2.1,2.3-3.6,3c-2.1,0.8-4.4,1.2-6.7,1.1h-3.5v-29l1.7-0.2c0.7-0.1,1.4-0.1,2.1-0.1c2-0.1,4,0.3,5.9,0.9
				c1.4,0.6,2.6,1.5,3.5,2.8c0.9,1.5,1.6,3.1,1.9,4.9c0.4,2.4,0.6,4.8,0.6,7.2C510.2,139.2,510.1,140.9,509.9,142.6 M539,184.6
				l-0.4,0.4c-0.6,0.6-1.4,1.3-2.2,2.1c-0.8,0.7-1.8,1-2.9,1c-0.8,0.1-1.7-0.1-2.4-0.6c-0.7-0.7-1.1-1.5-1.3-2.4
				c-0.4-1.9-0.7-3.7-0.8-5.6l-0.8-9.8c-0.1-3-0.8-5.9-2-8.6c-1-2.1-2.6-3.8-4.5-5.1c-2-1.3-4.3-2.2-6.6-2.7c-2-0.5-4.3-0.9-6.7-1.4
				c1.7-0.2,3.3-0.6,4.9-1c2.2-0.6,4.4-1.5,6.3-2.7c1.9-1.2,3.5-2.8,4.7-4.7c1.3-2.1,1.9-4.5,1.8-6.9c0.1-3-0.7-5.9-2.4-8.4
				c-1.6-2.2-3.6-4-6-5.3c-2.5-1.3-5.1-2.2-7.9-2.7c-2.7-0.5-5.4-0.8-8.1-0.8c-2.8,0-5.5,0.1-8.1,0.1c-2.7,0.1-5.4,0.1-8,0.1h-15.2
				v2.4h8.9v65.4h-8.9v2.4h33v-2.4h-8.9v-34h5.9c2.4-0.1,4.7,0.4,6.8,1.7c1.6,1.1,2.8,2.6,3.6,4.4c0.9,2.1,1.4,4.3,1.6,6.5
				c0.2,2.5,0.4,5.1,0.5,7.7c0.1,1.7,0.2,3.6,0.4,5.6c0.2,2,0.9,3.9,1.9,5.7c1.1,1.9,2.7,3.4,4.7,4.4c2.7,1.3,5.6,1.9,8.6,1.8
				c1.5,0,3-0.1,4.5-0.4c1.1-0.2,2.1-0.5,3.1-1c0.8-0.4,1.6-0.9,2.3-1.5c0.6-0.6,1.3-1.2,1.9-1.8l0.4-0.4L539,184.6z"
                        />
                        <path
                            id="Path_1276_00000034770245692720822540000001688527985011323569_"
                            style={{ fill: "#19274f" }}
                            d="M547,127.5c0.4-0.4,0.6-0.9,0.6-1.5
				c0-0.6-0.2-1.1-0.6-1.5c-0.5-0.3-1.1-0.5-1.7-0.5h-2.6v3.9h2.6C545.9,128,546.5,127.9,547,127.5 M548.2,130.7l2.2,3.6h-2.3
				l-2.2-3.8c-0.2-0.3-0.4-0.6-0.7-0.7c-0.3-0.2-0.7-0.2-1-0.2h-1.5v4.8h-2.1v-11.9h5c1.1-0.1,2.2,0.3,3,0.9
				c0.7,0.7,1.1,1.6,1.1,2.6c0,0.8-0.3,1.6-0.8,2.3c-0.6,0.6-1.4,1-2.3,1.1C547.3,129.6,547.9,130.1,548.2,130.7 M549.2,136.1
				c1.3-0.8,2.4-1.8,3.1-3.2c1.5-2.8,1.5-6.2,0-9c-0.7-1.3-1.8-2.4-3.1-3.2c-2.8-1.5-6.1-1.5-8.9,0c-1.3,0.8-2.4,1.8-3.2,3.2
				c-1.5,2.8-1.5,6.2,0,9c0.7,1.3,1.8,2.4,3.2,3.2C543.1,137.6,546.5,137.6,549.2,136.1 M549.9,119.7c1.5,0.9,2.8,2.1,3.6,3.6
				c1.8,3.2,1.8,7,0,10.2c-0.9,1.5-2.1,2.8-3.6,3.6c-4.9,2.8-11.1,1-13.9-3.8c-1.8-3.1-1.8-6.9,0-10c0.9-1.5,2.1-2.8,3.6-3.6
				C542.8,117.9,546.7,117.9,549.9,119.7"
                        />
                    </g>
                </g>
            </g>
            <path
                id="Path_28169"
                style={{
                    fill: "none",
                    stroke: "#19274f",
                    strokeWidth: 3,
                }}
                d="M374.9,197.1v166"
            />
            <g id="Group_9417">
                <path
                    id="Path_28170"
                    d="M25.1,21.5v9.7h24.1v64.4h10.1V31.2h24.1v-9.7H25.1z"
                />
                <path
                    id="Path_28171"
                    d="M107,21.5v74.1h54.6v-9.7H117V63.1h39.6v-9.7H117V31.2h44.1v-9.7H107z"
                />
                <path
                    id="Path_28172"
                    d="M247.5,21.5l-26.4,39l-26.5-39H186v74.1h9.9V41l23.6,34.3h3L246.1,41v54.6h10.1V21.5H247.5z"
                />
                <g id="Group_9416" transform="translate(0 0)">
                    <g>
                        <defs>
                            <rect
                                id="SVGID_00000087385618393778278280000005107175744917451948_"
                                x="25.1"
                                y="20.5"
                                width="990.8"
                                height="76.2"
                            />
                        </defs>
                        <clipPath id="SVGID_00000060005548846959690360000017617273705477125760_">
                            <use
                                xlinkHref="#SVGID_00000087385618393778278280000005107175744917451948_"
                                style={{ overflow: "visible" }}
                            />
                        </clipPath>
                        <g
                            id="Group_9415"
                            style={{
                                clipPath:
                                    "url(#SVGID_00000060005548846959690360000017617273705477125760_)",
                            }}
                        >
                            <path
                                id="Path_28173"
                                d="M311.2,60.1h-16.5V31.2h17.1c5.6,0,18.5,1.4,18.5,14.4C330.2,54.4,322.8,60.1,311.2,60.1 M312.2,21.5
					h-27.6v74.1h10.1V69.8h16.2c17.6,0,29.4-9.8,29.4-24.7C340.3,30.8,329.3,21.5,312.2,21.5"
                            />
                            <path
                                id="Path_28174"
                                d="M393.2,96.7c-19,0-30.8-12.4-30.8-32.3V21.5h10.1v42.4c0,14.7,7.6,23.2,20.9,23.2
					c13.2,0,20.5-8.1,20.5-22.7V21.5H424v42.3C424,84.1,412.2,96.7,393.2,96.7"
                            />
                            <path
                                id="Path_28175"
                                d="M461.5,57.4V31.2h21.1c11,0,17.4,4.6,17.4,12.8c0,8.1-6.9,13.3-17.7,13.3L461.5,57.4z M491.8,65.3
					c11.5-2.9,18.3-10.7,18.3-21.6c0-5.5-2.1-10.7-6-14.6c-4.9-4.9-12.4-7.5-21.2-7.5h-31.5v74.1h10.1V66.9h18.9l22,28.6h12.8
					L491.8,65.3z"
                            />
                            <path
                                id="Path_28176"
                                d="M663.6,96.6c-11.3,0-20.4-3.6-29.5-11.7l-1.8-1.6l6.6-7.6l1.9,1.7c7.5,6.9,14,9.6,23.1,9.6
					c8.9,0,15-4.6,15-11.2c0-5.2-1.3-9.2-17.6-12.5C643.6,59.7,636,53.1,636,41.4c0-12,10.6-20.9,24.7-20.9c10,0,17.3,2.6,25.2,8.9
					l1.9,1.6l-6.4,8l-1.9-1.7c-5.2-4.8-12-7.3-19-7.2c-8.4,0-14.4,4.4-14.4,10.6c0,5.1,1.4,9.5,18.2,12.9
					c11.5,2.3,24.7,6.9,24.7,21.5C689,87.6,678.3,96.6,663.6,96.6"
                            />
                            <path
                                id="Path_28177"
                                d="M771.2,95.6h-54.6V21.5h54.1v9.7h-44.1v22.2h39.6v9.7h-39.6v22.8h44.6L771.2,95.6z"
                            />
                            <path
                                id="Path_28178"
                                d="M812.3,66.6l14.4-31.6L841,66.6H812.3z M830.9,21h-8.1l-34.5,74.6h10.8l8.8-19.3h37.6l8.8,19.3h11.1
					L830.9,21z"
                            />
                            <path
                                id="Path_28179"
                                d="M938.2,95.6h-50.7V21.5h10.1v64.4h40.6L938.2,95.6z"
                            />
                            <path
                                id="Path_28180"
                                d="M984,95.6h-10.1v-29l-31.9-45h12.5l24.6,35.3l24.7-35.3h12.2L984,66.5V95.6z"
                            />
                            <rect
                                id="Rectangle_4306"
                                x="564.3"
                                y="26.2"
                                width="19.5"
                                height="21.1"
                            />
                            <rect
                                id="Rectangle_4307"
                                x="564.3"
                                y="66.8"
                                width="19.5"
                                height="21.1"
                            />
                            <rect
                                id="Rectangle_4308"
                                x="543.2"
                                y="47.3"
                                width="21.1"
                                height="19.5"
                            />
                            <rect
                                id="Rectangle_4309"
                                x="583.8"
                                y="47.3"
                                width="21.1"
                                height="19.5"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    ),
    stearnsLogo: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#00103b"
            viewBox="0 0 976.4 69.2"
        >
            <path
                d="M178.8,47.1c-0.6,2.5-1.5,4.9-2.6,7.1c-1.1,2.2-2.5,4.1-4.2,5.8c-1.6,1.6-3.6,2.9-5.7,3.8
        c-2.1,0.9-4.6,1.4-7.3,1.4h-14.2V33.7h5.5c2,0,3.7,0.3,5,1c1.3,0.7,2.5,1.6,3.4,2.8c0.9,1.2,1.7,2.6,2.2,4.1
        c0.6,1.6,1.1,3.3,1.5,5l0.1,0.4h2V18.1h-2l-0.1,0.4c-0.4,2-0.9,3.8-1.6,5.4c-0.6,1.6-1.5,3-2.4,4.1c-1,1.1-2.2,2-3.6,2.6
        c-1.5,0.6-3.3,0.9-5.4,0.9h-4.5V4.7h13.8c2.8,0,5.3,0.5,7.2,1.6c2,1.1,3.6,2.4,4.8,3.8c1.2,1.5,2.2,3,2.9,4.5
        c0.7,1.6,1.2,2.9,1.5,3.8l0.1,0.3h2V2.5h-54.6v2.2h8.3v60.4h-8.3v2.2h58.3V46.7h-2L178.8,47.1z"
            />
            <path
                d="M224.6,0.3L224.5,0h-3.1l-26.7,65.1H187v2.2H205v-2.2h-7.7l9.6-23.1h20.9l10,23.1h-8.1v2.2h31.1v-2.2h-7.9
        L224.6,0.3z M226.8,39.8h-19.2l9.3-22.8L226.8,39.8z"
            />
            <path
                d="M329.6,62.8c-0.6,0.6-1.3,1.2-2,1.9c-0.7,0.6-1.6,0.9-2.6,0.9c-1,0-1.7-0.2-2.2-0.5
        c-0.5-0.3-0.9-1.1-1.2-2.2c-0.3-1.2-0.6-3-0.7-5.2l-0.7-9.1c-0.2-3.3-0.9-5.9-1.9-7.9c-1-2-2.4-3.6-4.2-4.7
        c-1.7-1.1-3.8-1.9-6.1-2.5c-1.9-0.4-3.9-0.9-6.2-1.3c1.5-0.2,3-0.5,4.6-0.9c2.1-0.6,4.1-1.4,5.8-2.5c1.8-1.1,3.2-2.6,4.3-4.3
        c1.1-1.8,1.7-3.9,1.7-6.4c0-3.1-0.7-5.7-2.2-7.7c-1.4-2-3.3-3.7-5.5-4.9c-2.2-1.2-4.6-2-7.3-2.5c-2.6-0.5-5.1-0.7-7.5-0.7
        c-2.5,0-5.1,0-7.5,0.1c-2.5,0.1-5,0.1-7.4,0.1h-14v2.2h8.3v60.4h-8.3v2.2h30.5v-2.2H289V33.7h5.4c2.7,0,4.8,0.5,6.3,1.5
        c1.5,1,2.6,2.4,3.3,4.1c0.8,1.7,1.2,3.8,1.4,6c0.2,2.3,0.4,4.7,0.5,7.1c0.1,1.6,0.2,3.3,0.4,5.2c0.2,1.9,0.8,3.7,1.7,5.3
        c0.9,1.6,2.4,3,4.3,4.1c1.9,1.1,4.6,1.6,8,1.6c1.6,0,3-0.1,4.1-0.3c1.1-0.2,2.1-0.5,2.9-0.9c0.8-0.4,1.5-0.8,2.1-1.4
        c0.6-0.5,1.2-1.1,1.8-1.7l0.4-0.4l-1.6-1.5L329.6,62.8z M303.1,23.7c-0.2,1.5-0.7,2.8-1.4,4c-0.7,1.1-1.8,2.1-3.3,2.7
        c-1.5,0.7-3.6,1-6.2,1H289V4.7l1.5-0.1c0.6-0.1,1.3-0.1,1.9-0.1c2.2,0,4,0.3,5.4,0.9c1.4,0.6,2.5,1.4,3.2,2.6
        c0.8,1.2,1.4,2.7,1.7,4.5c0.4,1.9,0.5,4.1,0.5,6.7C303.4,20.6,303.3,22.2,303.1,23.7z"
            />
            <polygon
                points="379.9,4.7 388.2,4.7 388.2,44.4 358.9,2.5 336.9,2.5 336.9,4.7 345.2,4.7 345.2,65.1 336.9,65.1
        336.9,67.3 355.9,67.3 355.9,65.1 347.6,65.1 347.6,10.6 387.4,67.3 390.6,67.3 390.6,4.7 398.8,4.7 398.8,2.5 379.9,2.5"
            />
            <path
                d="M446.3,33.3c-1.8-1.5-3.9-2.7-6.3-3.6c-2.3-0.9-4.7-1.8-7.1-2.6c-2.4-0.8-4.8-1.5-7.1-2.2
        c-2.3-0.7-4.3-1.6-6.1-2.5c-1.7-1-3.1-2.1-4.2-3.4c-1-1.3-1.6-2.9-1.6-4.9c0-1.3,0.3-2.6,0.9-3.8c0.6-1.3,1.6-2.4,2.8-3.4
        c1.2-1,2.7-1.9,4.5-2.5c1.8-0.6,3.8-1,6.2-1c2.8,0,5.2,0.5,7,1.5c1.8,1,3.4,2.3,4.6,3.9c1.2,1.6,2.2,3.4,3,5.4
        c0.8,2,1.6,4.1,2.3,6.2l0.1,0.3h2v-18h-2.2L445,2.8c-0.3,0.8-0.6,1.2-0.7,1.3c-0.1,0.1-0.4,0.3-1.3,0.3c-0.7,0-1.4-0.2-2.2-0.5
        c-0.9-0.4-1.9-0.7-3-1.1c-1.1-0.4-2.5-0.8-4-1.1c-1.5-0.4-3.3-0.6-5.3-0.6c-3.2,0-6.1,0.5-8.8,1.6c-2.7,1.1-5.1,2.5-7,4.2
        c-1.9,1.7-3.5,3.8-4.6,6c-1.1,2.3-1.7,4.7-1.7,7.1c0,3.3,0.5,6.1,1.6,8.3c1.1,2.2,2.5,4.1,4.3,5.6c1.8,1.5,3.8,2.7,6,3.7
        c2.2,0.9,4.5,1.8,6.9,2.4l6.8,2c2.2,0.6,4.1,1.4,5.8,2.4c1.7,0.9,3,2.1,4,3.5c1,1.3,1.5,3.1,1.5,5.2c0,1.1-0.2,2.5-0.7,4
        c-0.5,1.5-1.3,3-2.4,4.4c-1.1,1.4-2.7,2.6-4.6,3.5c-2,1-4.5,1.4-7.6,1.4c-0.9,0-1.9,0-2.9,0c-1,0-2.1-0.2-3.2-0.5
        c-1.1-0.3-2.3-0.8-3.6-1.5c-1.2-0.7-2.5-1.7-3.9-3.1c-1.2-1.2-2.3-2.4-3.1-3.8c-0.9-1.4-1.6-2.7-2.1-4.1c-0.6-1.3-1-2.5-1.3-3.7
        c-0.3-1.1-0.5-2.1-0.6-2.8l-0.1-0.4h-2.2v20.9h2.3l0.1-0.3c0.3-0.9,0.6-1.3,0.8-1.4c0.2-0.1,0.6-0.3,1.5-0.3
        c0.5,0,1.4,0.2,2.6,0.5c1.2,0.4,2.7,0.7,4.2,1.1c1.6,0.4,3.3,0.8,5.1,1.1c1.8,0.4,3.7,0.5,5.6,0.5c3.7,0,7.2-0.6,10.3-1.8
        c3.1-1.2,5.7-2.8,8-4.8c2.2-2,4-4.4,5.2-7.1c1.2-2.7,1.8-5.6,1.8-8.5c0-3.1-0.6-5.7-1.7-7.8C449.6,36.6,448.1,34.8,446.3,33.3z"
            />
            <path
                d="M542.2,55l-0.1-0.3h-2.3l0.3,0.7c0.1,0.3,0.2,0.5,0.2,0.7c0,0.2,0,0.5,0,0.8c0,0.1,0,0.5-0.1,1.4
        c-0.1,0.7-0.3,1.4-0.6,2.1c-0.3,0.7-0.7,1.4-1.2,1.9c-0.4,0.5-1,0.7-1.8,0.7c-0.9,0-1.6-0.3-2.2-0.8c-0.6-0.6-1-1.1-1.2-1.5l-4-7
        c0.8-1.3,1.5-2.8,2.1-4.5c0.6-1.7,1-3.5,1.4-5.3c0.3-1.8,0.6-3.5,0.7-5.2c0.2-1.7,0.3-3.1,0.3-4.3c0.1-2.5,0.3-4.5,0.6-5.9
        c0.3-1.3,0.6-2.3,1.2-3c0.5-0.7,1.1-1.1,1.9-1.4c0.9-0.3,2-0.5,3.4-0.8l0.4-0.1v-2.1h-19.1v2.2h0.5c1.5,0,2.8,0.1,4,0.4
        c1.1,0.3,2,0.8,2.7,1.6c0.7,0.8,1.3,1.9,1.6,3.3c0.4,1.5,0.6,3.5,0.6,5.9c0,4.5-0.4,8.2-1.3,11.1v0c-0.7,2.4-1.4,4.2-2.1,5.4
        l-14.5-28.4c3.1-2.1,5.2-4.2,6.1-6.2c1-2.1,1.5-4,1.5-5.9c0-1.7-0.2-3.2-0.7-4.4c-0.5-1.2-1.1-2.2-2-3c-0.8-0.8-1.8-1.3-2.9-1.7
        c-2.6-0.8-5.7-0.7-8.5,0.7c-1.7,0.8-3.2,2-4.4,3.3c-1.3,1.4-2.3,3-3.1,4.7c-0.8,1.8-1.2,3.6-1.2,5.5c0,1.6,0.2,3.2,0.7,4.8
        c0.5,1.5,1.1,3.4,2,5.7c-1.8,1.1-3.7,2.4-5.6,3.7c-2,1.4-4,3-5.7,4.8c-1.7,1.8-3.2,3.8-4.3,6c-1.1,2.2-1.7,4.8-1.7,7.6
        c0,1.6,0.3,3.5,0.9,5.8c0.6,2.3,1.7,4.5,3.3,6.6c1.6,2.1,3.9,3.9,6.8,5.4c2.9,1.5,6.7,2.3,11.3,2.3c1.9,0,3.7-0.2,5.1-0.5
        c1.5-0.3,2.8-0.7,3.9-1.2c1.1-0.5,2.2-1.1,3.1-1.7c0.7-0.5,1.5-1.1,2.3-1.7c1,1.3,2.2,2.5,3.6,3.4c1.5,1.1,3.7,1.7,6.4,1.7
        c3,0,5.3-0.6,7-1.7c1.6-1.1,2.9-2.5,3.6-3.9c0.8-1.4,1.2-2.8,1.4-4.1c0.2-1.7,0.2-2.1,0.2-2.2c0-0.3,0-0.7-0.1-1
        C542.4,55.4,542.3,55.1,542.2,55z M508.2,9.1c0-1.5,0.2-2.6,0.7-3.4c0.5-0.8,1.1-1.4,1.7-1.7c0.6-0.4,1.2-0.6,1.8-0.6
        c0.6-0.1,1-0.1,1.2-0.1c1,0,1.8,0.2,2.5,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.7,0.8,1.6,1,2.5c0.2,0.9,0.3,1.8,0.3,2.8
        c0,1.4-0.2,2.7-0.7,3.7c-0.5,1.1-1.1,2.1-1.8,2.9c-0.7,0.8-1.5,1.6-2.3,2.1c-0.6,0.5-1.2,0.9-1.7,1.2c-0.5-0.8-0.9-1.6-1.4-2.5
        c-0.5-1.1-1.1-2.2-1.5-3.3c-0.4-1.1-0.8-2.1-1.1-3.2C508.3,10.9,508.2,9.9,508.2,9.1z M499.3,30.5c0.8-0.7,1.7-1.4,2.8-2.2
        c0.1,0.3,0.3,0.6,0.5,1.1c0.4,0.8,0.8,1.6,1.2,2.5L517.2,58c0.3,0.7,0.6,1.3,1,1.9c0.3,0.5,0.7,1.1,1.2,1.8
        c-1.3,1.1-2.6,1.9-3.8,2.6c-1.2,0.7-2.6,1.1-4.1,1.1c-1.3,0-2.7-0.5-4-1.4c-1.4-1-2.7-2.3-3.9-3.8c-1.2-1.6-2.3-3.3-3.4-5.3
        c-1-1.9-1.9-3.9-2.7-5.9c-0.7-2-1.3-3.8-1.7-5.5c-0.4-1.7-0.6-3.1-0.6-4.2c0-1.4,0.1-2.6,0.4-3.6c0.3-1,0.7-1.9,1.3-2.7
        C497.6,32.1,498.4,31.3,499.3,30.5z"
            />
            <path
                d="M572.3,4.7h8.3v60.4h-8.3v2.2h30.6v-2.2h-8.3V34.9h5.5c2,0,3.7,0.3,5,1c1.3,0.7,2.5,1.6,3.4,2.8
        c0.9,1.2,1.7,2.6,2.2,4.1c0.6,1.6,1.1,3.3,1.5,5l0.1,0.4h2V19.3h-2l-0.1,0.4c-0.4,2-0.9,3.8-1.6,5.4c-0.6,1.6-1.5,3-2.4,4.1
        c-1,1.1-2.2,2-3.6,2.6c-1.5,0.6-3.3,0.9-5.4,0.9h-4.5V4.7h13.1c2.3,0,4.4,0.3,6.1,1c1.7,0.6,3.2,1.6,4.5,2.7
        c1.3,1.2,2.4,2.6,3.4,4.3c1,1.7,1.9,3.6,2.7,5.8l0.1,0.3h2V2.5h-54V4.7z"
            />
            <path
                d="M687.8,10.2c-3.2-2.9-6.8-5.2-10.9-6.7c-7.9-3-15.9-3.3-24.4,0c-4,1.6-7.7,3.9-11,6.9c-3.3,3-6,6.6-8,10.7
        c-2.1,4.2-3.1,8.9-3.1,14c0,4.7,1,9.2,2.8,13.2c1.9,4,4.4,7.6,7.5,10.6c3.1,3,6.8,5.4,10.9,7.1c4.1,1.7,8.5,2.6,12.9,2.6
        c4.5,0,8.9-0.9,13-2.7c4.1-1.8,7.7-4.2,10.8-7.3c3.1-3.1,5.6-6.7,7.5-10.8c1.8-4.1,2.8-8.4,2.8-13c0-5.2-1-9.9-3-14.1
        C693.6,16.6,691,13.1,687.8,10.2z M683,34.3c0,4.6-0.2,9-0.5,12.9c-0.3,3.9-1.1,7.3-2.3,10.2c-1.2,2.8-3.1,5-5.5,6.6
        c-2.4,1.6-5.8,2.4-10.1,2.4c-3.3,0-6.1-0.5-8.5-1.4c-2.3-0.9-4.2-2.6-5.7-4.9c-1.5-2.4-2.6-5.6-3.3-9.6c-0.7-4-1.1-9.2-1.1-15.4
        c0-4.7,0.2-9.1,0.6-13c0.4-3.9,1.3-7.3,2.6-10.1c1.3-2.8,3.1-4.9,5.6-6.5s5.7-2.3,9.8-2.3c4.4,0,7.8,0.8,10.3,2.5
        c2.5,1.6,4.3,3.9,5.5,6.7c1.2,2.8,2,6.2,2.3,9.9C682.8,26.1,683,30.2,683,34.3z"
            />
            <path
                d="M748.6,33.3c-1.8-1.5-3.9-2.7-6.3-3.6c-2.3-0.9-4.7-1.8-7.1-2.6c-2.4-0.8-4.8-1.5-7.1-2.2
        c-2.3-0.7-4.3-1.6-6.1-2.5c-1.7-1-3.1-2.1-4.2-3.4c-1-1.3-1.6-2.9-1.6-4.9c0-1.3,0.3-2.6,0.9-3.8c0.6-1.3,1.6-2.4,2.8-3.4
        c1.2-1,2.7-1.9,4.5-2.5c1.8-0.6,3.8-1,6.2-1c2.8,0,5.2,0.5,7,1.5c1.8,1,3.4,2.3,4.6,3.9c1.2,1.6,2.2,3.4,3,5.4
        c0.8,2,1.6,4.1,2.3,6.2l0.1,0.3h2v-18h-2.2l-0.1,0.3c-0.3,0.8-0.6,1.2-0.7,1.3c-0.1,0.1-0.3,0.3-1.3,0.3c-0.6,0-1.4-0.2-2.2-0.5
        c-0.9-0.4-1.9-0.7-3-1.1c-1.1-0.4-2.5-0.8-4-1.1c-1.5-0.4-3.3-0.6-5.3-0.6c-3.2,0-6.1,0.5-8.8,1.6c-2.7,1.1-5.1,2.5-7,4.2
        c-2,1.7-3.5,3.8-4.6,6c-1.1,2.3-1.7,4.7-1.7,7.1c0,3.3,0.5,6.1,1.6,8.3c1.1,2.2,2.5,4.1,4.3,5.6c1.8,1.5,3.8,2.7,6,3.7
        c2.2,0.9,4.5,1.8,6.9,2.4l6.8,2c2.2,0.6,4.1,1.4,5.8,2.4c1.7,0.9,3,2.1,4,3.5c1,1.3,1.5,3.1,1.5,5.2c0,1.1-0.2,2.5-0.7,4
        c-0.5,1.5-1.3,3-2.4,4.4c-1.1,1.4-2.7,2.6-4.6,3.5c-2,1-4.5,1.4-7.6,1.4c-0.9,0-1.9,0-2.9,0c-1,0-2.1-0.2-3.2-0.5
        c-1.1-0.3-2.3-0.8-3.6-1.5c-1.2-0.7-2.5-1.7-3.9-3.1c-1.2-1.2-2.3-2.4-3.1-3.8c-0.9-1.4-1.6-2.7-2.1-4.1c-0.6-1.3-1-2.6-1.3-3.7
        c-0.3-1.2-0.5-2.1-0.6-2.8l-0.1-0.4h-2.2v20.9h2.3l0.1-0.3c0.3-0.9,0.6-1.3,0.8-1.4c0.2-0.1,0.6-0.3,1.5-0.3
        c0.5,0,1.4,0.2,2.6,0.5c1.2,0.4,2.7,0.7,4.2,1.1c1.6,0.4,3.3,0.8,5.1,1.1c1.8,0.4,3.7,0.5,5.6,0.5c3.7,0,7.2-0.6,10.3-1.8
        c3.1-1.2,5.7-2.8,8-4.8c2.2-2,4-4.4,5.2-7.1c1.2-2.7,1.8-5.6,1.8-8.5c0-3.1-0.6-5.7-1.7-7.8C751.9,36.6,750.4,34.8,748.6,33.3z"
            />
            <path
                d="M762.3,19.9h2l0.1-0.3c0.9-3,1.9-5.5,2.9-7.4c1-1.9,2.2-3.4,3.6-4.5c1.3-1.1,2.8-1.8,4.5-2.2
        c1.7-0.4,3.6-0.7,5.8-0.7h2.7v60.4h-8.3v2.2h30.5v-2.2h-8.3V4.7h2.7c2.2,0,4.1,0.2,5.8,0.7c1.7,0.4,3.2,1.2,4.5,2.2
        c1.3,1.1,2.5,2.6,3.6,4.5c1.1,1.9,2,4.4,2.9,7.4l0.1,0.3h2V2.5h-57.2V19.9z"
            />
            <path
                d="M43.1,33.3c-1.8-1.5-3.9-2.7-6.3-3.6c-2.3-0.9-4.7-1.8-7.1-2.6c-2.4-0.8-4.8-1.5-7.1-2.2
        c-2.3-0.7-4.3-1.6-6.1-2.5c-1.7-1-3.1-2.1-4.2-3.4c-1-1.3-1.6-2.9-1.6-4.9c0-1.3,0.3-2.6,0.9-3.8c0.6-1.3,1.6-2.4,2.8-3.4
        c1.2-1,2.7-1.9,4.5-2.5c1.8-0.6,3.8-1,6.2-1c2.8,0,5.2,0.5,7,1.5c1.8,1,3.4,2.3,4.6,3.9c1.2,1.6,2.2,3.4,3,5.4
        c0.8,2,1.6,4.1,2.3,6.2l0.1,0.3h2v-18h-2.2l-0.1,0.3c-0.3,0.8-0.6,1.2-0.7,1.3c-0.1,0.1-0.3,0.3-1.3,0.3c-0.6,0-1.4-0.2-2.2-0.5
        c-0.9-0.4-1.9-0.7-3-1.1c-1.1-0.4-2.5-0.8-4-1.1c-1.5-0.4-3.3-0.6-5.3-0.6c-3.2,0-6.1,0.5-8.8,1.6c-2.7,1.1-5.1,2.5-7,4.2
        c-2,1.7-3.5,3.8-4.6,6c-1.1,2.3-1.7,4.7-1.7,7.1c0,3.3,0.5,6.1,1.6,8.3c1.1,2.2,2.5,4.1,4.3,5.6c1.8,1.5,3.8,2.7,6,3.7
        c2.2,0.9,4.5,1.8,6.9,2.4l6.8,2c2.2,0.6,4.1,1.4,5.8,2.4c1.7,0.9,3,2.1,4,3.5c1,1.3,1.5,3.1,1.5,5.2c0,1.1-0.2,2.5-0.7,4
        c-0.5,1.5-1.3,3-2.4,4.4c-1.1,1.4-2.7,2.6-4.6,3.5c-2,1-4.5,1.4-7.6,1.4c-0.9,0-1.9,0-2.9,0c-1,0-2.1-0.2-3.2-0.5
        c-1.1-0.3-2.3-0.8-3.6-1.5c-1.2-0.7-2.5-1.7-3.9-3.1c-1.2-1.2-2.3-2.4-3.1-3.8C7.2,56,6.5,54.7,6,53.4c-0.6-1.3-1-2.6-1.3-3.7
        c-0.3-1.2-0.5-2.1-0.6-2.8L4,46.5H1.7v20.9H4L4.1,67c0.3-0.9,0.6-1.3,0.8-1.4c0.2-0.1,0.6-0.3,1.5-0.3c0.5,0,1.4,0.2,2.6,0.5
        c1.2,0.4,2.7,0.7,4.2,1.1c1.6,0.4,3.3,0.8,5.1,1.1c1.8,0.4,3.7,0.5,5.6,0.5c3.7,0,7.2-0.6,10.3-1.8c3.1-1.2,5.7-2.8,8-4.8
        c2.2-2,4-4.4,5.2-7.1c1.2-2.7,1.8-5.6,1.8-8.5c0-3.1-0.6-5.7-1.7-7.8C46.4,36.6,44.9,34.8,43.1,33.3z"
            />
            <path
                d="M56.8,19.9h2l0.1-0.3c0.9-3,1.9-5.5,2.9-7.4c1-1.9,2.2-3.4,3.6-4.5c1.3-1.1,2.8-1.8,4.5-2.2
        c1.7-0.4,3.6-0.7,5.8-0.7h2.7v60.4h-8.3v2.2h30.5v-2.2h-8.3V4.7h2.7c2.2,0,4.1,0.2,5.8,0.7c1.7,0.4,3.2,1.2,4.5,2.2
        c1.3,1.1,2.5,2.6,3.6,4.5c1.1,1.9,2,4.4,2.9,7.4l0.1,0.3h2V2.5H56.8V19.9z"
            />
            <path
                d="M884.2,47.1c-0.6,2.5-1.4,4.9-2.6,7.1c-1.1,2.2-2.5,4.1-4.2,5.8c-1.7,1.6-3.6,2.9-5.7,3.8
        c-2.1,0.9-4.6,1.4-7.3,1.4h-14.2V33.7h5.5c2,0,3.7,0.3,5,1c1.3,0.7,2.5,1.6,3.4,2.8c0.9,1.2,1.7,2.6,2.2,4.1
        c0.6,1.6,1.1,3.3,1.5,5L868,47h2V18.1h-2l-0.1,0.4c-0.4,2-0.9,3.8-1.6,5.4c-0.6,1.6-1.5,3-2.4,4.1c-1,1.1-2.2,2-3.6,2.6
        c-1.5,0.6-3.3,0.9-5.4,0.9h-4.5V4.7h13.8c2.8,0,5.3,0.5,7.2,1.6c2,1.1,3.6,2.4,4.8,3.8c1.2,1.4,2.2,3,2.9,4.5
        c0.7,1.5,1.2,2.8,1.5,3.8l0.1,0.3h2V2.5H828v2.2h8.3v60.4H828v2.2h58.3V46.7h-2L884.2,47.1z"
            />
            <path
                d="M958.6,62.5l-0.3,0.3c-0.6,0.6-1.3,1.2-2,1.9c-0.7,0.6-1.6,0.9-2.6,0.9c-1,0-1.7-0.2-2.2-0.5
        c-0.5-0.3-0.9-1.1-1.2-2.2c-0.3-1.2-0.6-3-0.8-5.2l-0.7-9.1c-0.2-3.3-0.9-5.9-1.9-7.9c-1-2-2.4-3.6-4.2-4.7
        c-1.7-1.1-3.8-1.9-6.1-2.5c-1.8-0.4-3.9-0.9-6.2-1.3c1.5-0.2,3-0.5,4.6-0.9c2.1-0.6,4.1-1.4,5.8-2.5c1.8-1.1,3.2-2.6,4.3-4.3
        c1.1-1.8,1.7-3.9,1.7-6.4c0-3.1-0.7-5.7-2.2-7.7c-1.4-2-3.3-3.7-5.5-4.9c-2.2-1.2-4.6-2-7.3-2.5c-2.6-0.5-5.1-0.7-7.5-0.7
        c-2.5,0-5.1,0-7.5,0.1c-2.5,0.1-5,0.1-7.4,0.1h-14v2.2h8.3v60.4h-8.3v2.2H926v-2.2h-8.3V33.7h5.4c2.7,0,4.8,0.5,6.3,1.5
        c1.5,1,2.6,2.4,3.3,4.1c0.8,1.7,1.2,3.8,1.4,6c0.2,2.3,0.4,4.7,0.5,7.1c0.1,1.6,0.2,3.3,0.4,5.2c0.2,1.9,0.8,3.7,1.7,5.3
        c0.9,1.6,2.4,3,4.3,4.1c1.9,1.1,4.6,1.6,8,1.6c1.6,0,3-0.1,4.1-0.3c1.1-0.2,2.1-0.5,2.9-0.9c0.8-0.4,1.5-0.8,2.1-1.4
        c0.6-0.5,1.2-1.1,1.8-1.7l0.4-0.4L958.6,62.5z M931.8,23.7c-0.2,1.5-0.7,2.8-1.4,4c-0.7,1.1-1.8,2.1-3.3,2.7c-1.5,0.7-3.6,1-6.2,1
        h-3.2V4.7l1.5-0.1c0.6-0.1,1.3-0.1,1.9-0.1c2.2,0,4,0.3,5.4,0.9c1.4,0.6,2.5,1.4,3.2,2.6c0.8,1.2,1.4,2.7,1.7,4.5
        c0.4,1.9,0.5,4.1,0.5,6.7C932.1,20.6,932,22.2,931.8,23.7z"
            />
            <path
                d="M968.8,2.5c1.4,0.8,2.5,1.9,3.3,3.3s1.2,3,1.2,4.7s-0.4,3.3-1.2,4.7c-0.8,1.4-1.9,2.5-3.4,3.4
        c-1.4,0.8-3,1.2-4.7,1.2c-1.7,0-3.3-0.4-4.7-1.2c-1.4-0.8-2.5-1.9-3.4-3.4c-0.8-1.4-1.2-3-1.2-4.7s0.4-3.3,1.2-4.7
        s1.9-2.5,3.4-3.3s3-1.2,4.7-1.2C965.8,1.3,967.4,1.7,968.8,2.5z M968.2,17.7c1.2-0.7,2.2-1.7,2.9-2.9c0.7-1.2,1.1-2.6,1.1-4.2
        c0-1.5-0.4-2.9-1.1-4.1c-0.7-1.2-1.7-2.2-2.9-2.9c-1.2-0.7-2.6-1.1-4.1-1.1s-2.9,0.4-4.1,1.1c-1.2,0.7-2.2,1.7-2.9,2.9
        c-0.7,1.2-1.1,2.6-1.1,4.1c0,1.5,0.4,2.9,1.1,4.2c0.7,1.2,1.7,2.2,2.9,2.9c1.2,0.7,2.6,1.1,4.1,1.1S966.9,18.4,968.2,17.7z
            M967.2,12.7l2,3.4h-2.2l-2.1-3.5c-0.2-0.3-0.4-0.6-0.7-0.7c-0.2-0.1-0.5-0.2-0.9-0.2h-1.4v4.4h-1.9v-11h4.6
        c1.2,0,2.2,0.3,2.8,0.9c0.7,0.6,1,1.4,1,2.4c0,0.9-0.2,1.6-0.7,2.1c-0.5,0.6-1.2,0.9-2.1,1C966.3,11.7,966.8,12.1,967.2,12.7z
            M966.1,9.8c0.3-0.3,0.5-0.7,0.5-1.3c0-0.6-0.2-1.1-0.5-1.4c-0.3-0.3-0.9-0.4-1.6-0.4h-2.4v3.6h2.4
        C965.2,10.2,965.8,10.1,966.1,9.8z"
            />
        </svg>
    ),
    barsIcon: (
        <svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
            <path d="M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z" />
        </svg>
    ),
    xIcon: (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1792 1792"
            xmlSpace="preserve"
        >
            <path
                d="M1087,896l429.6-429.6c25.9-26.6,25.9-68.9,0-95.5l-95.5-95.5c-26.6-25.9-68.9-25.9-95.5,0L896,705L466.4,275.4
	c-26.6-25.9-68.9-25.9-95.5,0l-95.5,95.5c-25.9,26.6-25.9,68.9,0,95.5L705,896l-429.6,429.6c-25.9,26.6-25.9,68.9,0,95.5l95.5,95.5
	c26.6,25.9,68.9,25.9,95.5,0L896,1087l429.6,429.6c26.6,25.9,68.9,25.9,95.5,0l95.5-95.5c25.9-26.6,25.9-68.9,0-95.5L1087,896z"
            />
        </svg>
    ),
    carretDownAccount: (
        <svg
            enableBackground="new 0 0 50 50"
            height="50px"
            id="Layer_1"
            version="1.1"
            viewBox="0 0 50 50"
            width="50px"
            xmlSpace="preserve"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <rect fill="none" height="50" width="50" />
            <polygon points="47.25,15 45.164,12.914 25,33.078 4.836,12.914 2.75,15 25,37.25 " />
        </svg>
    ),
    mobileAccount: (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 150 150"
            enableBackground="new 0 0 150 150"
            xmlSpace="preserve"
        >
            <path
                d="M72.3,72.4c19.6,0,35.6-16,35.6-35.6S91.9,1.3,72.3,1.3s-35.6,16-35.6,35.6S52.8,72.4,72.3,72.4z M72.3,7.4
	c16,0,29.2,13.1,29.2,29.2S88.4,65.7,72.3,65.7S43.2,52.6,43.2,36.5S56.3,7.4,72.3,7.4z"
            />
            <path
                d="M126.8,93.3c-6.4-8.3-14.4-15.4-24.4-20.2l-1.6-0.6l-1.6,1.3c-8,5.8-17.3,9-26.9,9s-18.9-3.2-26.9-9l-1.6-1.3l-1.6,1
	C18.8,84.9,4.1,108.3,4.1,134.6v3.2h92.3c5.1,6.7,13.1,10.9,22.4,10.9c15.4,0,28.2-12.5,28.2-28.2C147,107.7,138.4,96.8,126.8,93.3z
	 M92.9,131.1H10.5c1-21.8,13.5-41,32.7-51.3c8.7,5.8,18.6,9,28.8,9s20.5-3.2,28.8-9c6.1,3.2,11.5,7.4,16.3,12.5
	c-15.1,0.6-26.9,12.8-26.9,28.2C90.6,124,91.2,127.6,92.9,131.1z M132,137.5c-3.5,2.9-8.3,4.5-13.5,4.5c-5.1,0-9.6-1.6-13.5-4.5
	c-2.2-1.6-4.2-3.8-5.4-6.4c-1.9-3.2-2.9-6.7-2.9-10.6c0-11.9,9.6-21.8,21.8-21.8c1.6,0,2.9,0,4.5,0.3c4.2,1,7.7,2.9,10.6,5.8
	c4.2,3.8,6.7,9.6,6.7,15.7c0,1.6-0.3,3.2-0.6,4.8C138.7,130.1,136.1,134.3,132,137.5z"
            />
            <path
                d="M127.8,117l-9.3,9.3l-9.3-9.3c-0.6-0.6-1.6-0.6-2.2,0c-0.6,0.6-0.6,1.6,0,2.2l10.3,10.3c0.3,0.3,0.6,0.3,1.3,0.3
	c0.6,0,1,0,1.3-0.3l10.3-10.3c0.6-0.6,0.6-1.6,0-2.2C129.4,116.3,128.4,116.3,127.8,117z"
            />
        </svg>
    ),
    cartOpen: (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="115 61.5 35 27"
            enableBackground="new 115 61.5 35 27"
            xmlSpace="preserve"
        >
            <path
                d="M128.4,85.8c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2C129,87.1,128.4,86.5,128.4,85.8z
	 M131.9,85.8c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2C130.9,88,131.9,87.1,131.9,85.8z"
            />
            <path
                d="M143.1,84.6c0.7,0,1.2,0.6,1.2,1.2c0,0.6-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2C141.9,85.2,142.4,84.6,143.1,84.6z
	 M143.1,88c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2S141.9,88,143.1,88z"
            />
            <path
                d="M149.4,66.6c-0.1-0.1-0.7-0.4-0.9,0.2c-0.1,0.2-4,12.1-4,12.1h-16.2l-5.5-16.5c-0.1-0.2-0.3-0.3-0.5-0.3h-6.9v1h6.6
	l5.5,16.4v3.1c0,0.3,0.2,0.5,0.5,0.5h16.9v-1h-16.5v-2.2h16.4c0.2,0,0.4-0.1,0.5-0.3l4.2-12.5C149.5,66.9,149.5,66.8,149.4,66.6z"
            />
        </svg>
    ),
    // Add more icons as needed
};
